import { AuthenticationContext } from '~/contexts/AuthenticationContext';
import { useContext } from 'react';

export function useAuthentication() {
  const context = useContext(AuthenticationContext);

  if (!context) {
    throw new Error('Ensure not to call useAuthentication() outside AuthenticationProvider context.');
  }

  return context;
}
